import { render } from "./genericCRUD_tabelaPreco.vue?vue&type=template&id=22da4130"
import script from "./genericCRUD_tabelaPreco.vue?vue&type=script&lang=js"
export * from "./genericCRUD_tabelaPreco.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__